import React from 'react';
import cn from 'classnames';
import styles from './skeleton.module.scss';

export type SkeletonVariant = 'text' | 'circular' | 'rectangular' | 'rounded';
export type SkeletonAnimation = 'pulse' | 'wave' | 'none';

export interface SkeletonProps {
  /**
   * Вариант скелетона
   * @default 'rectangular'
   */
  variant?: SkeletonVariant;

  /**
   * Ширина скелетона
   */
  width?: string | number;

  /**
   * Высота скелетона
   */
  height?: string | number;

  /**
   * Тип анимации
   * @default 'pulse'
   */
  animation?: SkeletonAnimation;

  /**
   * Дополнительные CSS классы
   */
  className?: string;

  /**
   * Inline стили
   */
  style?: React.CSSProperties;

  /**
   * Количество строк для текстового скелетона
   * @default 1
   */
  lines?: number;

  /**
   * Отключить анимацию
   * @default false
   */
  disableAnimation?: boolean;
}

export const Skeleton: React.FC<SkeletonProps> = ({
  variant = 'rectangular',
  width,
  height,
  animation = 'pulse',
  className,
  style,
  lines = 1,
  disableAnimation = false
}) => {
  const inlineStyles: React.CSSProperties = {
    width,
    height,
    ...style
  };

  const skeletonClasses = cn(
    styles.skeleton,
    styles[`skeleton--${variant}`],
    !disableAnimation && styles[`skeleton--animation-${animation}`],
    className
  );

  if (variant === 'text' && lines > 1) {
    return (
      <div className={cn(styles.skeleton__container, className)}>
        {Array.from({ length: lines }).map((_, index) => (
          <div
            key={index}
            className={cn(
              styles.skeleton,
              styles['skeleton--text'],
              !disableAnimation && styles[`skeleton--animation-${animation}`],
              index === lines - 1 && styles['skeleton--text-last']
            )}
            style={{
              width: index === lines - 1 ? '60%' : width,
              height,
              ...style
            }}
          />
        ))}
      </div>
    );
  }

  return <div className={skeletonClasses} style={inlineStyles} />;
};
